module.exports = __webpack_public_path__ + "static/media/jackhammer.b6a02714.png";